export default __webpack_public_path__ + "static/media/leonie.54074629.png";